import { Injectable } from '@angular/core';

@Injectable()
export class LogService {

    // TODO: Production
    logs_enable = true;
    logInfo = true;
    logWarn = true;
    logError = true;


    constructor() { }

    printLog(title, message, type=''){

        if(this.logs_enable){

            switch(type){

                case 'logInfo':
                if(this.logInfo){
                    console.info(title, message);
                }
                break;

                case 'logWarn':
                if(this.logWarn){
                    console.warn(title, message);
                }
                break;

                case 'logError':
                if(this.logError){
                    console.error(title, message);
                }
                break;

                default:
                console.log(title, message);
            }

        }
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/services/log.service.ts